import { LoaderCircleIcon } from 'lucide-react';
import { Button } from '~/primitives/button';
import { useFormContext } from '~/util/hooks/useFormContext';
import { useDisableFormContext } from '../DisableContext';
import { cn } from '~/util';
export function SubscribeButton({
    label,
    classname,
}: {
    label: string;
    classname?: string;
}) {
    const form = useFormContext();
    const disabled = useDisableFormContext();
    return (
        <form.Subscribe
            selector={(state) => ({
                isSubmitting: state.isSubmitting,
                canSubmit: state.canSubmit,
            })}
        >
            {({ canSubmit, isSubmitting }) => (
                <>
                    <Button
                        type="submit"
                        className={cn(
                            'flex justify-center disabled:cursor-not-allowed',
                            classname,
                        )}
                        disabled={!canSubmit || disabled}
                    >
                        {isSubmitting && (
                            <LoaderCircleIcon className="animate-spin" />
                        )}
                        <p>{label}</p>
                    </Button>
                </>
            )}
        </form.Subscribe>
    );
}
